// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";

import { fetchPresetSequenceById } from "../../../store/equipment/equipmentActions";

export async function presetSequenceLoader({ params }) {
  const { sequenceId } = params;

  if (!sequenceId) {
    return null;
  }
  // fetch preset sequence by id
  store.dispatch(fetchPresetSequenceById(sequenceId));
  return null;
}

presetSequenceLoader.hydrate = true;
